<template>
  <aside class="company-nav">
    <h5>Company</h5>
    <nav>
      <router-link v-for="item in items" :key="item.to" :to="item.to" class="company-nav-link" :class="{ active: item.key === activeKey }">
        {{ item.label }}
      </router-link>
    </nav>
  </aside>
</template>

<script>
export default {
  name: 'companyNav',
  props: {
    activeKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      items: [
        { key: 'message', label: '代表挨拶', to: '/message' },
        { key: 'philosophy', label: '経営理念', to: '/philosophy' },
        { key: 'history', label: '会社沿革', to: '/history' },
        { key: 'business', label: '事業案内', to: '/business' },
        { key: 'profile', label: '会社概要', to: '/profile' },
        { key: 'technology', label: '技術分野', to: '/technology' },
        { key: 'access', label: 'アクセス', to: '/access' },
        { key: 'privacy', label: '個人情報保護方針', to: '/privacy' },
      ],
    };
  },
};
</script>
